export const INCREMENT_COUNTER = "INCREMENT_COUNTER";
export const DECREMENT_COUNTER = "DECREMENT_COUNTER";
export const SET_LOADING = "SET_LOADING";
export const SET_OVERLAY = "SET_OVERLAY";
export const SET_GLOBAL_VARIABLES = "SET_GLOBAL_VARIABLES";
export const NEXT_STEP = "NEXT_STEP";
export const PREV_STEP = "PREV_STEP";
export const SET_STEP = "SET_STEP";
export const UPDATE_FORM_ERROR = "UPDATE_FORM_ERROR";
export const SET_FORM_ERRORS = "SET_FORM_ERRORS";
export const TOGGLE_PRIMARY_COLOR = "TOGGLE_PRIMARY_COLOR";
export const SET_DISCOUNT = "SET_DISCOUNT";
export const REMOVE_DISCOUNT = "REMOVE_DISCOUNT";
export const UPDATE_PRODUCT_DETAIL = "UPDATE_PRODUCT_DETAIL";

export const OPEN_SNACK_BAR = "OPEN_SNACK_BAR";
export const CLOSE_SNACK_BAR = "CLOSE_SNACK_BAR";

export const SET_SEARCHABLE_PRODUCTS = "SET_SEARCHABLE_PRODUCTS";

export const SET_PAYMENT_TYPE = "SET_PAYMENT_TYPE";
